<template><!-- svgo-optimised -->
<svg class="icon icon__minus" viewBox="0 0 24 24" xmlns="http://www.w3.org/2000/svg"><path d="M12.553 12.453h-9.4a.5.5 0 0 1-.5-.5v-.106a.5.5 0 0 1 .5-.5H20.846a.5.5 0 0 1 .5.5v.106a.5.5 0 0 1-.5.5h-8.293Z" fill="#0F0F0F"/></svg>
</template>